const Mail = (props) => {
  const { emailAddress, children } = props;

  return (
    <a
      target="_top"
      href={"mailto:" + emailAddress}
      style={{
        color: "#009abb",
        textDecoration: "none",
      }}
    >
      {children}
    </a>
  );
};

export default Mail;
